import {Pane} from 'evergreen-ui';
import React from 'react';
import {ClientManagementLayout} from "../../layouts/ClientManagementLayout";
import {AuthorizationList} from "./AuthorizationList";
import {authorizationListReducer, initState} from "./authorizationListReducer";

export const AuthorizationListPage = () => {
    const [{
        pagination, sortBy, filter, selected, search, pageSize
    }, dispatch] = React.useReducer(authorizationListReducer, initState());

    return (
        <ClientManagementLayout customSelection={'Authorization'}>
            <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
                <AuthorizationList dispatch={dispatch}
                                pagination={pagination}
                                filterValue={filter}
                                selectedAuthorization={selected}
                                searchText={search}
                                sortBy={sortBy}
                                pageSize={pageSize}
                />
            </Pane>
        </ClientManagementLayout>
    );
}
